import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import ImageWithBasePath from '@/core/data/img/ImageWithBasePath';
import { all_routes } from '@/feature-module/router/all-routes';

import { UserType } from '../../auth/data/model/auth-model';
import useAuth from '../hooks/use-auth';

const Header = () => {
  const { user, isAuthenticated } = useAuth();
  const routes = all_routes;
  const location = useLocation();
  const onHandleMobileMenu = () => {
    const root = document.getElementsByTagName('html')[0];
    root.classList.add('menu-opened');
  };
  const onHandleCloseMenu = () => {
    const root = document.getElementsByTagName('html')[0];
    root.classList.remove('menu-opened');
  };
  // Define interface for header items to explicitly type roles
  interface HeaderItem {
    tittle: string;
    showAsTab: boolean;
    separateRoute: boolean;
    routes?: string;
    hasSubRoute?: boolean;
    showSubRoute?: boolean;
    roles?: UserType[];
    menu?: {
      menuValue: string;
      routes?: string;
      hasSubRoute: boolean;
      showSubRoute: boolean;
      showAsTab2?: boolean;
      subMenus?: {
        menuValue: string;
        routes?: string;
        hasSubRoute: boolean;
        showSubRoute: boolean;
        subMenus: any[];
      }[];
    }[];
  }

  const header: HeaderItem[] = [
    {
      tittle: 'Home',
      showAsTab: false,
      separateRoute: true,
      routes: routes.home,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: 'Admin',
      showAsTab: false,
      separateRoute: false,
      roles: [],
      menu: [
        // {
        //   menuValue: "Coaches Map",
        //   hasSubRoute: true,
        //   showSubRoute: true,
        //   showAsTab2: false,
        //   subMenus: [
        //     {
        //       menuValue: "Coaches Map",
        //       routes: routes.coachesMap,
        //       hasSubRoute: true,
        //       showSubRoute: true,
        //       subMenus: [],
        //     },
        //     {
        //       menuValue: "Coaches Map Sidebar",
        //       routes: routes.coachesMapSidebar,
        //       hasSubRoute: true,
        //       showSubRoute: true,
        //       subMenus: [],
        //     },
        //   ],
        // },
        // {
        //   menuValue: "Coaches Grid",
        //   routes: routes.coachesGrid,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   subMenus: [],
        // },
        // {
        //   menuValue: "Coaches List",
        //   routes: routes.coachesList,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   subMenus: [],
        // },
        // {
        //   menuValue: "Coaches Grid Sidebar",
        //   routes: routes.coachesGridSidebar,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   subMenus: [],
        // },
        // {
        //   menuValue: "Coaches List Sidebar",
        //   routes: routes.coachesListSidebar,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   subMenus: [],
        // },
        {
          menuValue: 'Booking',
          hasSubRoute: true,
          showSubRoute: true,
          showAsTab2: false,
          subMenus: [
            {
              menuValue: 'Book a Court',
              routes: routes.cageDetails,
              hasSubRoute: true,
              showSubRoute: true,
              subMenus: [],
            },
            {
              menuValue: 'Book a Coach',
              routes: routes.coachDetails,
              hasSubRoute: true,
              showSubRoute: true,
              subMenus: [],
            },
          ],
        },
        // {
        //   menuValue: "Coaches Details",
        //   routes: routes.coachDetails,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   subMenus: [],
        // },
        // {
        //   menuValue: "Venue",
        //   hasSubRoute: true,
        //   showSubRoute: true,
        //   showAsTab2: false,
        //   subMenus: [
        //     {
        //       menuValue: "Venue List",
        //       routes: routes.listingList,
        //       hasSubRoute: true,
        //       showSubRoute: true,
        //       subMenus: [],
        //     },
        //     {
        //       menuValue: "Venue Details",
        //       routes: routes.venueDetails,
        //       hasSubRoute: true,
        //       showSubRoute: true,
        //       subMenus: [],
        //     },
        //   ],
        // },
        {
          menuValue: 'Dashboard',
          routes: routes.coachDashboard,
          hasSubRoute: false,
          showSubRoute: false,
          subMenus: [],
        },
        {
          menuValue: 'Courts',
          routes: routes.allCourt,
          hasSubRoute: false,
          showSubRoute: false,
          subMenus: [],
        },
        {
          menuValue: 'List Your Cart',
          routes: routes.addCourt,
          hasSubRoute: false,
          showSubRoute: false,
          subMenus: [],
        },
        // {
        //   menuValue: "Chat",
        //   routes: routes.coachChat,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   subMenus: [],
        // },
      ],
    },
    {
      tittle: 'User',
      showAsTab: false,
      separateRoute: false,
      roles: [],
      menu: [
        {
          menuValue: 'Dashboard',
          routes: routes.userDashboard,
          hasSubRoute: false,
          showSubRoute: false,
          subMenus: [],
        },
        {
          menuValue: 'Bookings',
          routes: routes.userBookings,
          hasSubRoute: false,
          showSubRoute: false,
          subMenus: [],
        },
        // {
        //   menuValue: "Chat",
        //   routes: routes.userChat,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   subMenus: [],
        // },
        // {
        //   menuValue: "Invoice",
        //   routes: routes.userInvoice,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   subMenus: [],
        // },
        // {
        //   menuValue: "Wallet",
        //   routes: routes.userWallet,
        //   hasSubRoute: false,
        //   showSubRoute: false,
        //   subMenus: [],
        // },
        {
          menuValue: 'Profile Edit',
          routes: routes.userProfile,
          hasSubRoute: false,
          showSubRoute: false,
          subMenus: [],
        },
        {
          menuValue: 'Change Password',
          routes: routes.userSettingPassword,
          hasSubRoute: false,
          showSubRoute: false,
          subMenus: [],
        },
        {
          menuValue: 'Other Settings',
          routes: routes.profileOtherSetting,
          hasSubRoute: false,
          showSubRoute: false,
          subMenus: [],
        },
      ],
    },
    {
      tittle: 'About Us',
      showAsTab: false,
      separateRoute: true,
      routes: routes.aboutUs,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: 'Services',
      showAsTab: false,
      separateRoute: true,
      routes: routes.services,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: 'Events',
      showAsTab: false,
      separateRoute: true,
      routes: routes.events,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: 'Pricing',
      showAsTab: false,
      separateRoute: true,
      routes: routes.pricing,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: 'Gallery',
      showAsTab: false,
      separateRoute: true,
      routes: routes.gallery,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: 'Instructors',
      showAsTab: false,
      separateRoute: true,
      routes: routes.instructors,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: 'Testimonials',
      showAsTab: false,
      separateRoute: true,
      routes: routes.testimonials,
      hasSubRoute: false,
      showSubRoute: false,
    },
    {
      tittle: 'Contact Us',
      showAsTab: false,
      separateRoute: true,
      routes: routes.contactUs,
      hasSubRoute: false,
      showSubRoute: false,
    },
  ];
  const filteredNavMain = header.filter(
    item => !item.roles || (user && item.roles.includes(user.type as UserType))
  );
  const [headerState, setHeaderState] = useState<typeof header>(filteredNavMain);
  const customStyle = {
    background: 'rgb(23, 124, 130)',
    // location.pathname === routes.home ? "rgb(23, 124, 130)" : "#ffffff",
  };
  const expandSubMenus = (menu: string) => {
    sessionStorage.setItem('menuValue', menu);

    // Update `header` by toggling `showAsTab` for the clicked menu
    const updatedHeader = headerState.map(mainMenu => {
      if (mainMenu.tittle === menu) {
        // Toggle `showAsTab` for the selected `mainMenu`
        return { ...mainMenu, showAsTab: !mainMenu.showAsTab };
      } else {
        // Collapse all other menus
        return { ...mainMenu, showAsTab: false };
      }
    });

    // Use type assertion to force TypeScript to accept the update
    setHeaderState(updatedHeader as typeof header);
  };

  const expandSubMenus2 = (menu: string) => {
    sessionStorage.setItem('menuValue2', menu);

    const updatedHeader = headerState.map(mainMenu => {
      if (mainMenu.menu) {
        // Update nested menus if they exist
        const updatedMenu = mainMenu.menu.map(resMenu => {
          if (resMenu.menuValue === menu) {
            // Toggle the `showAsTab` for the selected menu
            return {
              ...resMenu,
              showAsTab2: false,
            };
          } else {
            // Collapse all other menus
            return {
              ...resMenu,
              showAsTab2: false,
            };
          }
        });

        return {
          ...mainMenu,
          menu: updatedMenu,
        };
      }

      return mainMenu;
    });

    // Use type assertion to force TypeScript to accept the update
    setHeaderState(updatedHeader as typeof header);
  };

  return (
    <header className={'header header-trans'} style={customStyle}>
      <div className="container-fluid">
        <nav className="navbar navbar-expand-lg header-nav">
          <div className="navbar-header">
            <button id="mobile_btn" className="btn btn-link" onClick={() => onHandleMobileMenu()}>
              <span className="bar-icon">
                <span />
                <span />
                <span />
              </span>
            </button>
            <Link to={routes.home} className="navbar-brand logo">
              {location.pathname === routes.home ? (
                <ImageWithBasePath
                  src="assets/img/logo.png"
                  className="img-fluid"
                  alt="Logo"
                  width={100}
                  height={42}
                  isBackend={false}
                />
              ) : (
                <ImageWithBasePath
                  src="assets/img/logo.png"
                  className="img-fluid"
                  alt="Another Image"
                  width={100}
                  height={42}
                  isBackend={false}
                />
              )}
            </Link>
          </div>
          <div className="main-menu-wrapper">
            <div className="menu-header">
              <Link to={routes.home} className="menu-logo">
                <ImageWithBasePath
                  src="assets/img/logo.png"
                  className="img-fluid"
                  alt="Logo"
                  width={100}
                  height={42}
                  isBackend={false}
                />
              </Link>
              <button
                id="menu_close"
                onClick={() => onHandleCloseMenu()}
                className="menu-close btn btn-link"
              >
                <i className="fas fa-times" />
              </button>
            </div>
            <ul className="main-nav">
              {headerState.map((mainMenus, mainIndex) => (
                <React.Fragment key={mainIndex}>
                  {mainMenus.separateRoute ? (
                    <>
                      <li
                        key={mainIndex}
                        className={location.pathname === (mainMenus.routes || '') ? 'active' : ''}
                        onClick={() => onHandleCloseMenu()}
                      >
                        <Link to={mainMenus.routes || '#'}>{mainMenus.tittle}</Link>
                      </li>
                    </>
                  ) : (
                    <li
                      className={`has-submenu ${mainMenus?.menu?.some(item => location.pathname === (item?.routes || '')) ? 'active' : ''}`}
                      onClick={() => onHandleCloseMenu()}
                    >
                      <a onClick={() => expandSubMenus(mainMenus.tittle)}>
                        {mainMenus.tittle} <i className="fas fa-chevron-down"></i>
                      </a>
                      <ul
                        className={`submenu ${mainMenus.showAsTab} ${mainMenus.showAsTab ? 'd-block' : ''}`}
                      >
                        {mainMenus.menu?.map((menu, menuIndex) => (
                          <React.Fragment key={`${mainIndex}-${menuIndex}`}>
                            {menu.hasSubRoute ? (
                              <li
                                key={`${mainIndex}-${menuIndex}`}
                                className={`${menu.hasSubRoute ? 'has-submenu' : ''} ${menu?.subMenus?.some(item => location.pathname === (item?.routes || '')) ? 'active' : ''}`}
                              >
                                <a
                                  className="hideonmob"
                                  onClick={() => {
                                    expandSubMenus2(menu.menuValue);
                                  }}
                                >
                                  {menu.menuValue}
                                </a>
                                <ul className={'submenu showonmob'}>
                                  {menu.subMenus?.map((subMenu, subMenuIndex) => (
                                    <li
                                      key={`${mainIndex}-${menuIndex}-${subMenuIndex}`}
                                      className={
                                        location.pathname === (subMenu.routes || '') ? 'active' : ''
                                      }
                                    >
                                      <Link to={subMenu.routes || '#'}>{subMenu.menuValue}</Link>
                                    </li>
                                  ))}
                                </ul>
                              </li>
                            ) : (
                              <li
                                key={`${mainIndex}-${menuIndex}`}
                                className={
                                  location.pathname === (menu.routes || '') ? 'active' : ''
                                }
                              >
                                <Link to={menu.routes || '#'}>{menu.menuValue}</Link>
                              </li>
                            )}
                          </React.Fragment>
                        ))}
                      </ul>
                    </li>
                  )}
                </React.Fragment>
              ))}
              <li className="d-lg-none">
                {isAuthenticated ? (
                  <Link
                    to={all_routes.dashboard}
                    className="nav-link btn btn-white log-register text-primary"
                    onClick={() => onHandleCloseMenu()}
                  >
                    <span>
                      <i className="feather-pie-chart" />
                    </span>
                    Dashboard
                  </Link>
                ) : (
                  <>
                    <Link
                      to={routes.login}
                      className="nav-link btn btn-white log-register text-primary"
                      onClick={() => onHandleCloseMenu()}
                    >
                      <span>
                        <i className="feather-users" />
                      </span>
                      Login
                    </Link>
                  </>
                )}
              </li>
            </ul>
          </div>
          <ul className="nav header-navbar-rht">
            <li className="nav-item">
              {isAuthenticated ? (
                <Link to={all_routes.dashboard} className="nav-link btn btn-white log-register">
                  <span>
                    <i className="feather-pie-chart" />
                  </span>
                  Dashboard
                </Link>
              ) : (
                <>
                  <Link to={routes.login} className="nav-link btn btn-white log-register">
                    <span>
                      <i className="feather-users" />
                    </span>
                    Login
                  </Link>
                </>
              )}
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
